import { CreditHelpers } from 'helpers/CreditHelpers';

export type WireSizingEnabledConnection = [string, string];

export type WireSizingEnabledConnections = WireSizingEnabledConnection[];

export type WireSizingConnection = {
    id: string;
    from: { componentInstanceId: string };
    to: { componentInstanceId: string };
};

const WireSizeChargingHelpers = {
    automatic: (
        project?: { wireSizing?: { automaticCharging?: boolean } } | null,
        team?: { hideCredits?: boolean } | null,
    ): boolean => CreditHelpers.hidden(team) || Boolean(project?.wireSizing?.automaticCharging),

    swr: {
        enabledConnections: (projectId: string) => `/projects/${projectId}/wire-sizing-enabled-connections`,
    },

    sortEndpoints: (connection: WireSizingConnection): WireSizingEnabledConnection => {
        return [
            connection.from.componentInstanceId,
            connection.to.componentInstanceId,
        ].sort() as WireSizingEnabledConnection;
    },

    enabled: (
        connections: ReadonlyArray<readonly [string, string]> | null | undefined,
        connection: WireSizingConnection,
    ): boolean => {
        const [from, to] = WireSizeChargingHelpers.sortEndpoints(connection);

        return Boolean(connections?.some((pair) => pair[0] === from && pair[1] === to));
    },

    add: (
        connections: WireSizingEnabledConnections,
        connection: WireSizingConnection,
    ): WireSizingEnabledConnections => {
        if (WireSizeChargingHelpers.enabled(connections, connection)) {
            return connections;
        }

        return [...connections, WireSizeChargingHelpers.sortEndpoints(connection)];
    },
};

export { WireSizeChargingHelpers };
